import {Component, OnInit} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import {StudyService} from "../../services/domain/study.service";
import {PreferencesService} from "../../services/domain/preferences.service";
import {RegistryService} from "../../services/domain/registry.service";
import {
  AnagraficaDto,
  AnagraficaUtenteCorsoFormazioneDto,
  AnagraficaUtenteVarieCVDataDto,
  AnagraficaUtenteVarieCVDto
} from "../../models/anagrafica.models";
import {AuthService} from "../../services/auth.service";
import {AnagraficaUtenteLavoroDesideratoDto, CorsoFormazioneDto, ProfiloPreferenze} from "../../models/preferenze.models";
import {SharedEnumModelKeyValue} from "../../models/shared.models";
import {WorkService} from "../../services/domain/work.service";
import {MansioniDto} from "../../models/lavoro.models";
import { AnagraficaUtenteConoscenzeDto } from 'src/app/models/istruzione.models';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.css'],
  providers: [PreferencesService,RegistryService, WorkService]
})
export class PreferencesComponent extends BasePageComponent  implements OnInit {

  constructor(private preferencesService : PreferencesService,
              private registryService : RegistryService,
              private workService : WorkService) {
    super();

  }

  public registryOtherInfo : AnagraficaUtenteVarieCVDataDto = new AnagraficaUtenteVarieCVDataDto();
  public lstLavoroDesiderato : AnagraficaUtenteLavoroDesideratoDto[] = [];
  public lstCorsiFormazione : CorsoFormazioneDto[] = [];
  public lstTipoOrari : SharedEnumModelKeyValue[] = [];
  public taskList : MansioniDto[] = [];
  public formazione : ProfiloPreferenze[] = [];
  public formazioneObj : ProfiloPreferenze = new ProfiloPreferenze();
  public registryDto : AnagraficaDto = new AnagraficaDto();
  public profileSex : string = "";

  ngOnInit(): void {
    this.getInfoAvailability();
    this.getRegistryDetail();
    this.getAnagraficaUtenteLavoroDesideratoGetList();
  }

  public getInfoAvailability(){
    this.asyncCall(() => this.registryService.getInfoAvailabilityAndCv(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.registryOtherInfo = response.Item || new AnagraficaUtenteVarieCVDataDto();

      if(this.registryOtherInfo.VarieCV == null)
        this.registryOtherInfo.VarieCV = new AnagraficaUtenteVarieCVDto();

      for (let i = 0; i < this.registryOtherInfo.DisponibilitaOrario.length ; i++){
        this.registryOtherInfo.DisponibilitaOrario[i].Key = this.registryOtherInfo.DisponibilitaOrario[i].IdDisponibilitaOrario;
        this.registryOtherInfo.DisponibilitaOrario[i].Value = this.registryOtherInfo.DisponibilitaOrario[i].DisponibilitaOrario;
      }
      for (let i = 0; i < this.registryOtherInfo.CorsiFormazione.length; i++){
        this.registryOtherInfo.CorsiFormazione[i].IdCorso = this.registryOtherInfo.CorsiFormazione[i].IdCorso;
        this.registryOtherInfo.CorsiFormazione[i].CorsoDesc = this.registryOtherInfo.CorsiFormazione[i].CorsoDesc;
      }
    });
  }

  public getRegistryDetail(){
    this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
      this.registryDto = response.Item || new AnagraficaDto();
      this.profileSex = this.registryDto.Sesso;
    });
  }

  public getAnagraficaUtenteLavoroDesideratoGetList(){
    this.asyncCall(() => this.preferencesService.getAnagraficaUtenteLavoroDesiderato(AuthService.LoggedUser?.profileId ?? 0), response => {
      this.lstLavoroDesiderato = response.Items || [];
    });
  }

  //getRicercaCorsiFormazione effettua la ricerca secondo la stringa che va a prendere e restituisce e risultati che matchano
  //response.Items ritorna la lista con i match e la assegna a lstCorsiFormazione che la mostra
  public getRicercaCorsi(event : any){
    this.asyncCall(() => this.preferencesService.getRicercaCorsiFormazione(event.query), response => {
      this.lstCorsiFormazione = response.Items || [];
      for( let j = 0 ; j < this.registryOtherInfo.CorsiFormazione.length; j++){
        this.lstCorsiFormazione = this.lstCorsiFormazione.filter(x => x.IdCorso != this.registryOtherInfo.CorsiFormazione[j].IdCorso);
      }
    });
  }

  public getMansioni(event : any){
    // if(this.lstLavoroDesiderato.length == 3)
    //   return this.showWarning("Puoi selezionare fino a 3 Mansioni");

    if(event.query.length < 3)
      return;

    this.asyncCall(() => this.workService.getTaskAutocomplete(event.query), response => {
      this.taskList = response.Items || [];
      for( let j = 0; j < this.lstLavoroDesiderato.length; j++){
        this.taskList = this.taskList.filter(x => x.IdMansione != this.lstLavoroDesiderato[j].IdMansione);
      }
    });

  }


  public getOrarioPreferenze(event : any){
    this.asyncCall(() => this.preferencesService.getOrarioPreferenze(event.query), response => {
      this.lstTipoOrari = response.Items || [];
      for( let j = 0 ; j < this.registryOtherInfo.DisponibilitaOrario.length; j++){
        this.lstTipoOrari = this.lstTipoOrari.filter(x => x.Key != this.registryOtherInfo.DisponibilitaOrario[j].Key);
      }

    });
  }

  public flushField(){
    while(this.registryOtherInfo.CorsiFormazione.length != 0){
      this.registryOtherInfo.CorsiFormazione.splice(0);
    }
  }
  public getPreferencesUpsert(){
    this.formazioneObj.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;

//SALVATAGGIO TIPO DI MANSIONE
    if(this.lstLavoroDesiderato.length > 0){
      this.formazioneObj.IdMansioneList = '';
      for(let i=0; i < this.lstLavoroDesiderato.length; i++){
        if(i == this.lstLavoroDesiderato.length-1)
          this.formazioneObj.IdMansioneList += this.lstLavoroDesiderato[i].IdMansione;
        else
          this.formazioneObj.IdMansioneList += this.lstLavoroDesiderato[i].IdMansione + ',';
      }
    }

//SALVATAGGIO CORSI DI FORMAZIONE
    if(this.registryOtherInfo.CorsiFormazione.length > 0){
      this.formazioneObj.CorsiFormazione = '';
      for(let i=0; i < this.registryOtherInfo.CorsiFormazione.length; i++){
        if(i == this.registryOtherInfo.CorsiFormazione.length-1){
          this.formazioneObj.CorsiFormazione += this.registryOtherInfo.CorsiFormazione[i].IdCorso;
        }
        else
          this.formazioneObj.CorsiFormazione += this.registryOtherInfo.CorsiFormazione[i].IdCorso + ",";
      }
      this.registryOtherInfo.CorsiFormazione.length;
    }

//SALVATAGGIO DISPONIBILITA' ORARIO
    if(this.registryOtherInfo.DisponibilitaOrario.length > 0){
      this.formazioneObj.DisponibilitaOrarioList = '';
      for(let i=0; i < this.registryOtherInfo.DisponibilitaOrario.length; i++){
        if(i == this.registryOtherInfo.DisponibilitaOrario.length -1){
          this.formazioneObj.DisponibilitaOrarioList += this.registryOtherInfo.DisponibilitaOrario[i].Key;
        }
        else{
          this.formazioneObj.DisponibilitaOrarioList += this.registryOtherInfo.DisponibilitaOrario[i].Key + ",";
        }

      }
    }

//SALVATAGGIO ALTRE DISPONIBILITA'
    this.formazioneObj.DisponibilitaFrequentareCorsi = this.registryOtherInfo.VarieCV.DisponibilitaFrequentareCorsi;
    this.formazioneObj.DisponibilitaPolitcheAttive = this.registryOtherInfo.VarieCV.DisponibilitaPolitcheAttive.valueOf();
    this.formazioneObj.CategoriaProtetta = this.registryOtherInfo.VarieCV.CategoriaProtetta;
    this.formazioneObj.PatenteA = this.registryOtherInfo.VarieCV.PatenteA;
    this.formazioneObj.PatenteB = this.registryOtherInfo.VarieCV.PatenteB;
    this.formazioneObj.PatenteC = this.registryOtherInfo.VarieCV.PatenteC;
    this.formazioneObj.PatenteD = this.registryOtherInfo.VarieCV.PatenteD;
    this.formazioneObj.PatenteE = this.registryOtherInfo.VarieCV.PatenteE;
    this.formazioneObj.Automunito = this.registryOtherInfo.VarieCV.Automunito;

    this.asyncCall(() => this.preferencesService.getUpdatePreferenze(this.formazioneObj), response => {
      this.showMessageSaveCompleted();
    });
  }

  private setTipoOrari(){
    this.lstTipoOrari.push(new SharedEnumModelKeyValue())
  }


}
